import { scrollToSection } from "utils/scrollToSection";

export function Hero() {
    return (
        <section id="hero" className="section hero">
            <div className="hero__container container">
                <div className="hero__content hero-content">
                    <div className="hero__badge badge">
                        <span className="hero__badge-dot pulse-dot"></span>
                        <span className="hero__badge-text">Ваши идеи — мой код</span>
                    </div>
                    <h1 className="hero__title">
                        Разработка MVP для быстрой проверки гипотез
                    </h1>
                    <p className="hero__description description">
                        Помогаю бизнесу выйти на рынок с минимальными вложениями через разработку на React и Next.js
                    </p>
                    {/* <p className="hero__description description">
                        Помогаю бизнесу выйти на рынок с минимальными вложениями, создавая быстрые и стабильные продукты на React и Next.js.
                    </p> */}
                    {/* <p className="hero__description description">
                        Создание быстрых и интерактивных интерфейсов, которые работают как полноценные приложения.
                    </p> */}
                    <div className="hero__actions hero-buttons">
                        <button 
                            type='button' 
                            onClick={() => scrollToSection('contact')} 
                            className="hero__button hero__button--primary"
                        >
                            <span className="hero__button-text">Начать новый проект</span>
                            <svg className="hero__button-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <line x1="5" y1="12" x2="19" y2="12"></line>
                                <polyline points="12 5 19 12 12 19"></polyline>
                            </svg>
                        </button>
                        <button 
                            type='button' 
                            onClick={() => scrollToSection('expert-advice')} 
                            className="hero__button hero__button--secondary"
                        >
                            <svg className="hero__button-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <circle cx="12" cy="12" r="10"></circle>
                                <line x1="12" y1="8" x2="12" y2="16"></line>
                                <line x1="8" y1="12" x2="16" y2="12"></line>
                            </svg>
                            <span className="hero__button-text">Узнать больше</span>
                        </button>
                    </div>
                </div>
                <div className="hero__scroll scroll-indicator">
                    <span className="hero__scroll-text">Листай вниз</span>
                    <svg className="hero__scroll-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <polyline points="19 12 12 19 5 12"></polyline>
                    </svg>
                </div>
            </div>
        </section>
    );
}
// interface HeroProps {
//     scrollToSection: (sectionId: string) => void;
// }

// export function Hero({ scrollToSection }: HeroProps) {
//     return (
//         <section id="hero" className="section hero">
//             <div className="hero__container container">
//                 <div className="hero__content hero-content">
//                     <div className="hero__badge badge">
//                         <span className="hero__badge-dot pulse-dot"></span>
//                         <span className="hero__badge-text">синергия опыта и инноваций</span>
//                     </div>
//                     <h1 className="hero__title">
//                         Современная веб-разработка и <span className="accent">создание сайтов под ключ</span>
//                     </h1>
//                     <p className="hero__description description">
//                         Индивидуальные решения на React и SPA для быстрого роста вашего бизнеса.
//                     </p>
//                     <div className="hero__actions hero-buttons">
//                         <button 
//                             type='button' 
//                             onClick={() => scrollToSection('contact')} 
//                             className="hero__button hero__button--primary"
//                         >
//                             <span className="hero__button-text">Начать новый проект</span>
//                             <svg className="hero__button-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                 <line x1="5" y1="12" x2="19" y2="12"></line>
//                                 <polyline points="12 5 19 12 12 19"></polyline>
//                             </svg>
//                         </button>
//                         <button 
//                             type='button' 
//                             onClick={() => scrollToSection('innovations')} 
//                             className="hero__button hero__button--secondary"
//                         >
//                             <svg className="hero__button-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                 <circle cx="12" cy="12" r="10"></circle>
//                                 <line x1="12" y1="8" x2="12" y2="16"></line>
//                                 <line x1="8" y1="12" x2="16" y2="12"></line>
//                             </svg>
//                             <span className="hero__button-text">Узнать больше</span>
//                         </button>
//                         {/* <button type='button' className="btn-secondary">
//                             <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
//                                 <polygon points="5 3 19 12 5 21 5 3"></polygon>
//                             </svg>
//                                 Смотреть демо
//                         </button> */}
//                     </div>
//                 </div>
//                 <div className="hero__scroll scroll-indicator">
//                     <span className="hero__scroll-text">Листай вниз</span>
//                     <svg className="hero__scroll-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                         <line x1="12" y1="5" x2="12" y2="19"></line>
//                         <polyline points="19 12 12 19 5 12"></polyline>
//                     </svg>
//                 </div>
//             </div>
//         </section>
//     );
// }
